import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewRelatedRoomTags from './viewRelatedRoomTags';

export default {
  title: 'Android XR Images',
  attributeName: 'sportsRoom',
  fields: [
    {
      attributeName: 'heroImage',
      type: FormInputTypes.DOWNLOADABLE,
      allowedSizes: [
        { width: 848, height: 306 }
      ],
      
      hasSelect:false,
      label: 'Hero Banner - 848x306',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
    },
    {
      attributeName: 'thumbnailImage',
      type: FormInputTypes.DOWNLOADABLE,
      // aspectRatio: '159:332',
      allowedSizes: [
        { width: 160, height: 160 }
      ],
      hasSelect:false,
      label: 'Space Thumbnail - 160x160',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
    },

    {
      attributeName: 'spaceHeader',
      type: FormInputTypes.DOWNLOADABLE,
      allowedSizes: [
        { width: 928, height: 334 }
      ],
      
      hasSelect:false,
      label: 'Top Banner 928x334',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
    },
    
  ],
};
